module.exports = __webpack_public_path__ + "static/favicon-f112c19c132975db1cb62ac793d03aa7.ico";